/*
 * <cookie-banner> — KVKK / cerez onay banner'i.
 *
 * Ilk ziyarette gosterilir. Kullanici "Tumunu kabul et" veya "Yalnizca zorunlu"
 * sectiginde tercih localStorage'a yazilir ve banner bir daha gosterilmez.
 * Mevcutsa Shopify Customer Privacy API'sine de izin durumu bildirilir.
 * Footer'daki href="#cookie-settings" link (veya [data-open-cookie-settings])
 * tiklandiginda banner yeniden acilir.
 */
const COOKIE_CONSENT_KEY = 'felicitas_cookie_consent';

class CookieBanner extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-cookie-accept]')?.addEventListener('click', () => this.choose('granted'));
    this.querySelector('[data-cookie-decline]')?.addEventListener('click', () => this.choose('denied'));

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-cookie-settings], a[href="#cookie-settings"]');
      if (!trigger) return;
      event.preventDefault();
      this.open();
    });

    let saved = null;
    try {
      saved = localStorage.getItem(COOKIE_CONSENT_KEY);
    } catch (error) {
      saved = null;
    }

    if (saved === 'granted' || saved === 'denied') {
      this.applyConsent(saved);
    } else {
      this.open();
    }
  }

  open() {
    this.hidden = false;
  }

  choose(decision) {
    try {
      localStorage.setItem(COOKIE_CONSENT_KEY, decision);
    } catch (error) {
      /* localStorage kapali olabilir; yine de tercihi uygula */
    }
    this.applyConsent(decision);
    this.hidden = true;
  }

  applyConsent(decision) {
    const granted = decision === 'granted';
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      try {
        privacy.setTrackingConsent(
          {
            analytics: granted,
            marketing: granted,
            preferences: granted,
            sale_of_data: granted,
          },
          () => {}
        );
      } catch (error) {
        /* API hazir degilse sessizce gec */
      }
    }
  }
}

if (!customElements.get('cookie-banner')) {
  customElements.define('cookie-banner', CookieBanner);
}
